<p class="pretext">
  <transloco
    id="830489ed-570a-4549-843f-1f368c7dfcb3"
    [key]="toContinueInstructionsTranslationId.key"
    [params]="toContinueInstructionsTranslationId.params"
    [scope]="toContinueInstructionsTranslationId.scope"></transloco>
</p>

<yat-polling-status id="7770f6e2-5bbc-4f4e-b544-849409bfaf02" [configuration]="extendedConfiguration"><yat-email-clip id="d4b7c8bf-e670-4cfa-af34-0c7d9e6ba244" [email]="email"></yat-email-clip></yat-polling-status>

<ng-container *ngIf="!proceeding">
  <div class="subtext" yat-link>
    <transloco
      id="5b489498-c763-4f0e-ac41-1ed3886a35bb"
      [key]="
        scenario === 'academic'
          ? 'accountUi.verifyEmailUi.resendEmailOrLinks.resendEmailOrChangeYourAcademicEmailAddress'
          : scenario === 'secondaryEmail'
          ? 'accountUi.verifyEmailUi.resendEmailOrLinks.resendEmailOrChangeYourEmailAddress'
          : (accountIdLinked$ | async) && scenario === 'SIGN_UP'
          ? 'accountUi.verifyEmailUi.resendEmailOrLinks.resendEmailOrConnectAccountAnotherWay'
          : 'accountUi.verifyEmailUi.resendEmailOrLinks.resendEmailOrSignInAnotherWay'
      "
      [params]="{ resendEmailLink, changeYourEmailAddressLink }"></transloco>
  </div>
</ng-container>
